import React, { Fragment, Component } from "react";
import { properties } from "../constants/Propertise";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {
  Alert
} from 'reactstrap';

class DefaultMessages extends Component {

  render() {

    return (
      <Fragment>

        {
          (
            (this.props.apiError === true) &&
            (this.props.isPending === false)
          ) &&
          <Alert color="danger">{ properties.globalUserErrorMessage }</Alert>
        }

        {
          (
            (this.props.apiError === false) &&
            (this.props.isPending === true)
          ) &&
          <SkeletonTheme>
            <Skeleton count={this.props.count} duration={1} height={20}/>
          </SkeletonTheme>
        }

        {
          (
            (this.props.apiError === true) &&
            (this.props.isPending === true)
          ) &&
          <Alert color="danger">{ properties.globalUserErrorMessage }</Alert>
        }

      </Fragment>
    )
  }

}

export default DefaultMessages;